import { HORIZON, SEISMIC_SURVEY } from '@core/core/constants'
import type { BaseObjectProperties, Calculation, HorizonCalculation } from '@core/core/types'
import type { FC } from 'react'

import { FIRST_CALCULATION_ID } from '../../../../constants'
import { SelectGroup } from '../../SelectGroup'

type HorizonObjectsProps = {
  calculation: Calculation
  updateCalculation: (calc: Calculation) => void
  cubeName: string | undefined
}

export const HorizonObjects: FC<HorizonObjectsProps> = ({
  calculation,
  updateCalculation,
  cubeName,
}) => {
  const params = calculation.params as HorizonCalculation

  const update = (field: keyof HorizonCalculation) => (value: BaseObjectProperties) => {
    updateCalculation({ ...calculation, params: { ...params, [field]: value } })
  }

  return (
    <>
      {calculation.id === FIRST_CALCULATION_ID && (
        <SelectGroup
          type={SEISMIC_SURVEY}
          withParams={true}
          value={params.seismicSurvey}
          onChange={update('seismicSurvey')}
        />
      )}
      <SelectGroup
        type={HORIZON}
        withParams={true}
        value={params.horizon}
        cubeName={cubeName}
        onChange={update('horizon')}
      />
    </>
  )
}
